import { IdleQueue } from 'idlefy/min';

const queue = new IdleQueue({ ensureTasksRun: true });

const delayedScheduler = (callback: any, timeout?: number) => {
  // Check if requestIdleCallback is supported
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    // Push the callback to the non-critical queue
    try {
      queue.pushTask(() => callback());
    } catch (error) {
      //eslint-disable-next-line no-console
      console.error('Exception in pushToNonCriticalQueue', error);
    }
  } else {
    // Fallback to setTimeout if requestIdleCallback is not available
    if (timeout) {
      setTimeout(callback, timeout);
    } else {
      setTimeout(callback);
    }
  }
};

export default delayedScheduler;
